<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 5: Please complete the following information
    </h2>
    <form @submit.prevent="passes(submitForm)">
      <d-field label="Estimated Commencement Date">
        <d-datepicker v-model="estimatedCommencementDate" icon="calendar" expanded />
      </d-field>
      <d-field label="Referenced Standard for this project" rules="required">
        <div>
          <div class="mb-2">
            <d-radio v-model="projectStandard" native-value="Architectural Woodwork Standards Edition 1">
              Architectural Woodwork Standards Edition 1
            </d-radio>
          </div>
          <div>
            <d-radio v-model="projectStandard" native-value="Architectural Woodwork Standards Edition 2">
              Architectural Woodwork Standards Edition 2
            </d-radio>
          </div>
        </div>
      </d-field>

      <div class="my-10">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3">
            <h4>Project Scope</h4>
          </div>
          <div class="hidden md:block md:w-1/3">
            <h4>Premium</h4>
          </div>
          <div class="hidden md:block md:w-1/3">
            <h4>Custom</h4>
          </div>
        </div>

        <div v-for="(scope, index) in projectScopeOptions" :key="index" class="flex flex-wrap mb-1">
          <div class="w-full md:w-1/3" v-text="scope.title" />
          <div class="w-1/2 md:w-1/3">
            <d-checkbox v-model="projectScopes" :native-value="scope.premium">
              {{ scope.premium }}
            </d-checkbox>
          </div>
          <div class="w-1/2 md:w-1/3">
            <d-checkbox v-model="projectScopes" :native-value="scope.custom">
              {{ scope.custom }}
            </d-checkbox>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0" :loading="submitting">
          Submit
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_UPDATE_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions, mapState } = createNamespacedHelpers('projectUpdateForm');

  export default {
    data: () => ({
      projectScopeOptions: [
        {
          title: 'Factory Finishing',
          premium: 'P5',
          custom: 'C5',
        },
        {
          title: 'Millwork',
          premium: 'P6',
          custom: 'C6',
        },
        {
          title: 'Stairwork & Rails',
          premium: 'P7',
          custom: 'C7',
        },
        {
          title: 'Wall Surfacing',
          premium: 'P8',
          custom: 'C8',
        },
        {
          title: 'Architectural Doors',
          premium: 'P9',
          custom: 'C9',
        },
        {
          title: 'Casework',
          premium: 'P10',
          custom: 'C10',
        },
        {
          title: 'Countertops',
          premium: 'P11',
          custom: 'C11',
        },
        {
          title: 'Historic Restoration',
          premium: 'P12',
          custom: 'C12',
        },
      ],
    }),

    computed: {
      ...mapFields({
        fields: ['estimatedCommencementDate', 'projectStandard', 'projectScopes'],
        module: 'projectUpdateForm',
        base: 'formFields',
        mutation: PROJECT_UPDATE_FORM.FORM_FIELDS,
      }),
      ...mapState([
        'submitting',
      ]),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'submitForm',
      ]),
    },
  };
</script>